import React from 'react';

const AppArtwork = () => (
  <svg
    className="app-artwork"
    viewBox="0 0 320 200"
    role="img"
    aria-labelledby="docmerge-artwork-title"
  >
    <title id="docmerge-artwork-title">DocMerge artwork</title>
    <defs>
      <linearGradient id="docmerge-bg" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f766e" />
        <stop offset="100%" stopColor="#22a89f" />
      </linearGradient>
      <linearGradient id="docmerge-accent" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#f59e0b" />
        <stop offset="100%" stopColor="#fbbf24" />
      </linearGradient>
    </defs>
    <rect x="8" y="8" width="304" height="184" rx="26" fill="url(#docmerge-bg)" />
    <rect x="40" y="40" width="110" height="120" rx="16" fill="rgba(255,255,255,0.94)" />
    <rect x="170" y="40" width="110" height="120" rx="16" fill="rgba(255,255,255,0.94)" />
    <path d="M145 100h30" stroke="#0f766e" strokeWidth="8" strokeLinecap="round" />
    <path d="M150 80h20v40h-20z" fill="url(#docmerge-accent)" />
    <path
      d="M63 75h64M63 96h52M63 117h58"
      stroke="#0f766e"
      strokeWidth="7"
      strokeLinecap="round"
      opacity="0.85"
    />
    <path
      d="M193 75h64M193 96h48M193 117h56"
      stroke="#0f766e"
      strokeWidth="7"
      strokeLinecap="round"
      opacity="0.85"
    />
  </svg>
);

export default AppArtwork;
